import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import authService from "../services/authService";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";
import "./Auth.css";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ password: "", confirmPassword: "" });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validarSenha = (senha) => {
    const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%])[A-Za-z\d!@#$%]{8,16}$/;
    return regex.test(senha);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setMessage("❌ As senhas não coincidem.");
      return;
    }

    if (!validarSenha(formData.password)) {
      setMessage("❌ A senha deve conter entre 8 e 16 caracteres, incluindo letras, números e um caractere especial (!@#$%).");
      return;
    }

    try {
      const response = await authService.resetPassword(token, { password: formData.password });
      setMessage(response.data.message || "✅ Senha redefinida com sucesso!");
      setTimeout(() => navigate("/login"), 3000); // redireciona após sucesso
    } catch (error) {
      setMessage(error.response?.data?.error || "❌ Erro ao resetar senha");
    }
  };

  return (
    <AppLayout>
      <div className="auth-container">
        <h2>🔑 Resetar Senha</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="password"
            name="password"
            placeholder="Digite sua nova senha"
            value={formData.password}
            onChange={handleChange}
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirme sua nova senha"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
          <button type="submit" className="auth-button">Salvar Senha</button>
        </form>
        {message && <p className="auth-message">{message}</p>}
      </div>
      <Footer />
    </AppLayout>
  );
}

export default ResetPassword;
